import { CountryRegionApiDto, ResidenceCountryApiDto } from '@lx/shared/api/models';

export type CountryRegion = CountryRegionApiDto & { weight?: number };

export type CountryRegionType = ResidenceCountryApiDto.CountryRegionTypeEnum;
export const CountryRegionTypeEnum = ResidenceCountryApiDto.CountryRegionTypeEnum;
